"use client";

import { usePathname } from "next/navigation";
import { useEffect, useRef } from "react";

import { env } from "../../env.config";

const isDocsPath = (pathname: string) => pathname.includes("/docs");

export const CustomerChatProvider = () => {
  const pathname = usePathname();
  const configuredRef = useRef(false);

  useEffect(() => {
    if (configuredRef.current) {
      return;
    }

    const loadCrisp = async () => {
      if (configuredRef.current) {
        return;
      }

      configuredRef.current = true;
      const { ChatboxPosition, Crisp } = await import("crisp-sdk-web");
      Crisp.configure(env.NEXT_PUBLIC_CRISP_WEBSITE_ID);
      Crisp.setPosition(
        isDocsPath(pathname) ? ChatboxPosition.Left : ChatboxPosition.Right,
      );
    };

    const timeout = window.setTimeout(loadCrisp, 5000);

    const onInteraction = () => {
      window.clearTimeout(timeout);
      void loadCrisp();
    };

    window.addEventListener("scroll", onInteraction, {
      once: true,
      passive: true,
    });
    window.addEventListener("pointerdown", onInteraction, { once: true });

    return () => {
      window.clearTimeout(timeout);
      window.removeEventListener("scroll", onInteraction);
      window.removeEventListener("pointerdown", onInteraction);
    };
  }, [pathname]);

  useEffect(() => {
    if (!configuredRef.current) {
      return;
    }

    void import("crisp-sdk-web").then(({ ChatboxPosition, Crisp }) => {
      return Crisp.setPosition(
        isDocsPath(pathname) ? ChatboxPosition.Left : ChatboxPosition.Right,
      );
    });
  }, [pathname]);

  return null;
};
